import { Component } from '@angular/core';

@Component({
  selector: 'supplier-feedback',
  templateUrl: './supplier-feedback.component.html',
})
// this component is a route outlet for both the feedback details screen and the feedback list screen
export class SupplierFeedbackComponent {}
